<template>
  <div class="card">
    <h3>获取Ticket中的信息</h3>
    <h4>接口调用请求说明</h4>
    <p>http请求方式：POST <a href="javascript:void(0)">http://xa.celer.cc/open/ticket_info/</a>
    </p>
    <h4>请求示例</h4>
    <json-viewer
      class="code"
      :value="jsonData"
    ></json-viewer>
    <h4>JSON字段说明</h4>
    <table class="param_table">
      <tr>
        <td>
          <h4>键值</h4>
        </td>
        <td>
          <h4>类型</h4>
        </td>
        <td>
          <h4>是否必须</h4>
        </td>
        <td>
          <h4>说明</h4>
        </td>
      </tr>
      <tr>
        <td>ticket</td>
        <td>String</td>
        <td>是</td>
        <td>Ticket</td>
      </tr>
    </table>

    <h4>调用URL示例</h4>
    <p>http://xa.celer.cc/open/ticket_info/</p>
    <h4>返回结果</h4>
    <p>正确时的返回JSON数据包如下：</p>
    <json-viewer
      class="code"
      :value="jsonData1"
    ></json-viewer>
  </div>
</template>

<script>
export default {
  name: 'TicketInfo',
  data () {
    return {
      jsonData: {
        ticket: '3d337d7bcf3e85b85e8adeac36d21f93be673f********************************************e90cfb677d67c922a916738dc7e3f84db3db7d2ce'
      },
      jsonData1: {
        code: '200',
        ticket_info: {
          username: 'admin',
          user_id: 1,
          app_id: 16,
          join_type: 0,
          experiment_student_id: 5
        }
      }
    }
  }
}
</script>

<style scoped>
.card {
  border: 1px solid #eee;
  padding: 20px;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

p {
  word-wrap: break-word;
  word-break: break-all;
}

a {
  word-wrap: break-word;
  word-break: break-all;
}

div {
  word-wrap: break-word;
  word-break: break-all;
}

.param_table {
  width: 800px;
}

.param_table tr td {
  border-bottom: 1px solid #ddd;
  padding: 7px;
}

.param_table tr td:first-child {
  width: 150px;
  text-align: left;
  vertical-align: top;
}

.param_table tr:last-child td {
  border-bottom: none;
}

.code {
  width: 1000px;
  padding: 7px;
  border-radius: 5px;
  border: 1px solid #aaa;
  background-color: #eee;
  margin-bottom: 15px;
}

.jv-container.jv-light {
  background: #eee;
}

h3,
h4,
h5 {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>
